module.exports = __webpack_public_path__ + "img/pay.e0fce444.png";